<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.5 0L13 11.2583L0 11.2583L6.5 0Z" fill="currentColor"/>
</svg>
